module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inbound-status-card"
  }, [_c('div', {
    staticClass: "status-header"
  }, [_c('h5', [_vm._v("Inbound Status")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text",
      "size": "mini",
      "icon": "el-icon-refresh",
      "loading": _vm.refreshing
    },
    on: {
      "click": _vm.refreshStatus
    }
  }, [_vm._v("\n      Refresh\n    ")])], 1), _vm._v(" "), (_vm.hasValidData) ? _c('div', {
    staticClass: "status-content"
  }, [_c('div', {
    staticClass: "status-grid"
  }, [_c('div', {
    staticClass: "status-item"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Take Quantity:")]), _vm._v(" "), _c('span', {
    staticClass: "value primary"
  }, [_vm._v(_vm._s(_vm.takeQuantity))])]), _vm._v(" "), _c('div', {
    staticClass: "status-item"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Total Remaining:")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.totalRemaining))])]), _vm._v(" "), (_vm.safePendingClaims > 0) ? _c('div', {
    staticClass: "status-item warning"
  }, [_vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.safePendingClaims))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "status-item success"
  }, [_vm._m(1), _vm._v(" "), _c('span', {
    staticClass: "value emphasis"
  }, [_vm._v(_vm._s(_vm.availableToClaim))])]), _vm._v(" "), (_vm.safePrice !== null) ? _c('div', {
    staticClass: "status-item"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Price:")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v("$" + _vm._s(_vm.safePrice.toFixed(2)))])]) : _vm._e()]), _vm._v(" "), (_vm.safePendingClaims > 0) ? _c('div', {
    staticClass: "pending-note"
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_c('i', {
    staticClass: "el-icon-info"
  }), _vm._v("\n        " + _vm._s(_vm.safePendingClaims) + " items awaiting warehouse review\n      ")])]) : _vm._e()]) : _c('div', {
    staticClass: "no-data-state"
  }, [_vm._m(2)]), _vm._v(" "), (_vm.pendingClaims > 0) ? _c('div', {
    staticClass: "status-tips"
  }, [_c('el-alert', {
    attrs: {
      "title": "Notice",
      "description": _vm.getStatusTipMessage(),
      "type": "info",
      "closable": false,
      "show-icon": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showActions && _vm.hasValidData) ? _c('div', {
    staticClass: "status-actions"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "disabled": _vm.availableToClaim <= 0
    },
    on: {
      "click": function($event) {
        return _vm.$emit('select-inbound', _vm.inbound)
      }
    }
  }, [_vm._v("\n      Select This Inbound\n    ")])], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('i', {
    staticClass: "el-icon-warning"
  }), _vm._v("\n          Pending Claims:\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('i', {
    staticClass: "el-icon-check"
  }), _vm._v("\n          Available:\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "no-data-content"
  }, [_c('i', {
    staticClass: "el-icon-warning"
  }), _vm._v(" "), _c('p', [_vm._v("No inbound data available")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f532c88"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/InboundStatusCard.vue
// module id = 843
// module chunks = 1